import React, { Suspense, useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { Spin } from "antd";
import { Modal as BootstrapModal } from 'react-bootstrap';
import moment from 'moment';
import { Link } from "react-router-dom";
// Import your image sources
import signal2 from '../../../assets/img/secondsignal.png';
import signal3 from '../../../assets/img/signal3.png';
import signal4 from '../../../assets/img/signal4.png';
import signal5 from '../../../assets/img/signal5.png';
import { BootstrapTooltip } from '../../../Commoncomponet/common';

// Throttle function to limit scroll event frequency
const throttle = (func, limit) => {
    let lastFunc;
    let lastRan;
    return function (...args) {
        if (!lastRan) {
            func.apply(this, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(() => {
                if ((Date.now() - lastRan) >= limit) {
                    func.apply(this, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
};

export default function VirtualizationModal({
    isModalVisible,
    handleCancel,
    ModelId,
    tableData,
    ModalLoad,
    tabShow,
    Download_Logs,
    AllCategory,
    MeterDetails,
    onHandaleViewGSM,
    getSecondsTodayBydate,
    seconTominutesConveter,
    exports,
}) {
    const [visibleRows, setVisibleRows] = useState(50);
    const [sortedData, setSortedData] = useState(tableData || []);
    const modalBodyRef = useRef(null);

    useEffect(() => {
        setVisibleRows(Math.min(50, tableData.length));
        setSortedData(tableData);
    }, [isModalVisible, tableData]);

    useEffect(() => {
        if (!isModalVisible || !modalBodyRef.current) return;

        const handleScroll = throttle(() => {
            const element = modalBodyRef.current;
            const { scrollTop, scrollHeight, clientHeight } = element;
            
            // Calculate 70% of the total scrollable height
            const triggerPoint = scrollHeight * 0.85;
            
            // Check if current scroll position has crossed 70% mark
            if (scrollTop + clientHeight >= triggerPoint) {
                setVisibleRows(prev => {
                    const next = prev + 50;
                    return next >= tableData.length ? tableData.length : next;
                });
            }
        }, 200);

        const scrollElement = modalBodyRef.current;
        scrollElement.addEventListener('scroll', handleScroll);

        return () => {
            scrollElement.removeEventListener('scroll', handleScroll);
        };
    }, [isModalVisible, tableData.length]);

    return (
        <Suspense fallback={<Spin size="large" />}>
            <BootstrapModal className="my-modal-className" show={isModalVisible} onHide={handleCancel} size={"xl"} backdrop="static" keyboard={false}>
                <BootstrapModal.Header closeButton={!ModalLoad}>
                    <BootstrapModal.Title style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>
                        {ModelId}{sortedData.length > 0
                            ? <span className='btn btn-primary text-white ml-2' onClick={Download_Logs}><i className='fas fa-download'></i></span> : ''}
                        {sortedData.length > 0
                            ? <Link to={{
                                pathname: `All-GSM`, state: {
                                    detail: sortedData.map(
                                        (data) => (data?.UNIQUE_ID)), title: ModelId
                                }
                            }}><span className='btn btn-primary text-white ml-2'><i className='fas fa-up-right-from-square'></i></span></Link> : ''}
                    </BootstrapModal.Title>
                </BootstrapModal.Header>
                <BootstrapModal.Body ref={modalBodyRef} style={{ maxHeight: '90vh', overflow: 'auto', paddingTop: '0px' }}>
                    <div className="modal-table">
                        {ModalLoad ? (
                            <div className="example">
                                <Spin size="large" />
                            </div>
                        ) : (
                            <table className="table border table-borderless" id="table-1">
                                <thead style={{ position: 'sticky', top: '0', background: '#fff' }}>
                                    <tr>
                                        <th className="text-center">SR NO.</th>
                                        <th className="text-center">Consumer Name</th>
                                        <th className="text-center">Modem Serial No</th>
                                        <th className="text-center">Category</th>
                                        <th className="text-center">RSSI</th>
                                        <th className="text-center">Installation Number</th>
                                        {tabShow === true ? '' : <th className="text-center">EVC Type</th>}
                                        {tabShow === true ? '' : <th className="text-center">Battery Percent</th>}
                                        {tabShow === true ? '' : <th className="text-center">Predicted Battery Percent</th>}
                                        {/* 1.2 T3090 new added to show consumer status */}
                                        {ModelId === 'Total Consumers' ? <th className="text-center">Consumers Status</th> : ''}
                                        {tabShow === true ? '' : <th className="text-center">Heartbeat Last Seen</th>}
                                        {tabShow === true ? '' : <th className="text-center">Total up time (Minutes)</th>}
                                        {tabShow === true ? '' : <th className="text-center">Maximum up time (Minutes)</th>}
                                        {tabShow === true ? '' : <th className="text-center">Device wake-up count</th>}
                                        {tabShow === false && ModelId == 'Under Maintanance' ? <th className="text-center">Change Status Time</th> : ''}

                                    </tr>
                                </thead>
                                <tbody id="tbody">
                                    {sortedData.length > 0 ?
                                        sortedData.slice(0, visibleRows).map((data, id) => (
                                            <tr style={{ height: "4rem", cursor: 'pointer' }} className="trheigth even:tw-bg-gray-100 hover:tw-bg-[#D8D8D8]" key={id} onMouseEnter={() => {
                                                var element = document.getElementById(data?.UNIQUE_ID + 'GSM');
                                                element.classList.add('within');
                                                element.classList.remove('display-icon');
                                            }} onMouseLeave={() => {
                                                var element = document.getElementById(data?.UNIQUE_ID + 'GSM');
                                                element.classList.add('display-icon');
                                                element.classList.remove('within');
                                            }}>
                                                <td className="GSM_Link">
                                                    <a className="!tw-text-[#1890ff]" onClick={() => onHandaleViewGSM(data?.UNIQUE_ID)}>{id + 1}</a>
                                                    <a id={data?.UNIQUE_ID + 'GSM'} className='display-icon !tw-text-[#1890ff]' onClick={() => onHandaleViewGSM(data?.UNIQUE_ID)}><img src={exports} style={{ height: "10px" }} /></a></td>
                                                <td className="text-center">{data?.address_compony_name}</td>
                                                <td className="text-center">{data?.DEVICE_SERIAL_NO}</td>
                                                <td className='tw-min-w-[150px] text-center' >
														{AllCategory?.category5.filter((inac) => (inac?.UNIQUE_ID === data?.CAT5_ID))[0]?.NAME || AllCategory?.category4.filter((inac) => (inac?.CATEGORY4_UNIQUE_ID === data?.CAT4_ID))[0]?.CATEGORY4_NAME || AllCategory?.category3.filter((inac) => (inac?.CATEGORY3_UNIQUE_ID === data?.CAT3_ID))[0]?.CATEGORY3_NAME || AllCategory?.category2.filter((inac) => (inac?.CATEGORY2_UNIQUE_ID === data?.CAT2_ID))[0]?.CATEGORY2_NAME || AllCategory?.category1.filter((inac) => (inac?.CATEGORY1_UNIQUE_ID === data?.CAT1_ID))[0]?.CATEGORY1_NAME || AllCategory?.category0.filter((inac) => (inac?.UNIQUE_ID === data?.CAT0_ID))[0]?.CATEGORY0}
													</td>
                                                <td className="text-center">
                                                    {data?.RSSI >= 2 && data?.RSSI <= 9 ? (
                                                        <>
                                                            <img alt="signal2" src={signal2} style={{ height: '20px', width: "40px", border: '0', boxShadow: 'none', borderRadius: 'none' }} />
                                                            <span className="text-center">{data?.RSSI} </span>
                                                        </>
                                                    ) : data?.RSSI >= 10 && data?.RSSI <= 14 ? (
                                                        <>
                                                            <img alt="signal3" src={signal3} style={{ height: '20px', width: "40px", border: '0', borderRadius: '0', boxShadow: 'none' }} />
                                                            <span className="text-center">{data?.RSSI} </span>
                                                        </>
                                                    ) : data?.RSSI >= 15 && data?.RSSI <= 19 ? (
                                                        <>
                                                            <img alt="signal4" src={signal4} style={{ height: '20px', width: "40px", border: '0', borderRadius: '0', boxShadow: 'none' }} />
                                                            <span className="text-center">{data?.RSSI} </span>
                                                        </>
                                                    ) : data?.RSSI >= 20 && data?.RSSI <= 31 ? (
                                                        <>
                                                            <img alt="signal5" src={signal5} style={{ height: '20px', width: "40px", border: '0', borderRadius: '0', boxShadow: 'none' }} />
                                                            <span className="text-center">{data?.RSSI} </span>
                                                        </>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>

                                                {/* {tabShow === true ? '' :<BootstrapTooltip title={<div>
                                                                                                                            ACCOUNT:{data?.CAT0_ID}
                                                                                                                            <br />
                                                                                                                            CATEGORY1:{data?.CAT1_ID}
                                                                                                                            <br />
                                                                                                                            CATEGORY2:{data?.CAT2_ID}
                                                                                                                            <br />
                                                                                                                            CATEGORY3:{data?.CAT3_ID}
                                                                                                                            <br />
                                                                                                                            CATEGORY4:{data?.CAT4_ID}
                                                                                                                            <br />
                                                                                                                            CATEGORY5:{data?.CAT5_ID}
                                                                                                                        </div>} placement='top'><td><b className='tw-font-semibold'>ACCOUNT:</b><br />{data?.CAT0_ID}</td></BootstrapTooltip>} */}
                                                <td className="text-center">{data?.INSTALLATION_NUMBER}</td>
                                                {tabShow === true ? '' : <td className="text-center">{MeterDetails.filter((info) => (info?.METER_TYPE == data?.METER_TYPE))[0]?.METER_PROFILE_NAME || ''}</td>}
                                                {tabShow === true ? '' : <td className="text-center">{data?.BAT_PER} %</td>}
                                                {tabShow === true ? '' : <td className="text-center">{data?.MAX_DEVICE_UP_TIME_SEC && JSON.parse(data?.HEARTBEAT_LAST_DATA || '{}')?.TOTALDUPTIME ? (((data?.MAX_DEVICE_UP_TIME_SEC - JSON.parse(data?.HEARTBEAT_LAST_DATA || '{}')?.TOTALDUPTIME) * 100) / data?.MAX_DEVICE_UP_TIME_SEC) > 0 ? (((data?.MAX_DEVICE_UP_TIME_SEC - JSON.parse(data?.HEARTBEAT_LAST_DATA || '{}')?.TOTALDUPTIME) * 100) / data?.MAX_DEVICE_UP_TIME_SEC).toFixed(2) : '0' : ''}%</td>}
                                                {/* 1.2 T3090 new added */}
                                                {ModelId === 'Total Consumers' ?
                                                    <td className="text-center">
                                                        <div className={`badge ${data?.CUSTOMER_STATUS == 1 ? 'badge-success' : data?.CUSTOMER_STATUS == -1 ? 'badge-warning' : data?.CUSTOMER_STATUS == 0 ? 'badge-danger' : data?.CUSTOMER_STATUS == 2 ? 'badge-info' : 'badge-dark'} badge-shadow text-white`}>{data?.CUSTOMER_STATUS == 1 ? 'Active' : data?.CUSTOMER_STATUS == -1 ? 'Pending Configuration' : data?.CUSTOMER_STATUS == 0 ? 'Inactive' : data?.CUSTOMER_STATUS == 2 ? 'Under Maintenance' : 'Stand By'}</div>
                                                    </td>
                                                    : ""}

                                                {tabShow === true ? '' : <td className="text-center">{getSecondsTodayBydate(data.HEARTBEAT_TS) < 86400 ? <div className="badge badge-success badge-shadow text-white">{data?.HEARTBEAT_TS ? moment.utc(data.HEARTBEAT_TS).add(-moment().utcOffset(), "m").fromNow('ss:hh:mm') : ''}</div> : <div className="badge badge-danger badge-shadow text-white">{data?.HEARTBEAT_TS ? moment.utc(data.HEARTBEAT_TS).add(-moment().utcOffset(), "m").fromNow('ss:hh:mm') : ''}</div>}</td>}
                                                {tabShow === true ? '' : <td className="text-center">{JSON.parse(data?.HEARTBEAT_LAST_DATA || '{}')?.TOTALDUPTIME ? seconTominutesConveter(JSON.parse(data?.HEARTBEAT_LAST_DATA || '{}')?.TOTALDUPTIME) : '0'}</td>}
                                                {tabShow === true ? '' : <td className="text-center">{data?.MAX_DEVICE_UP_TIME_SEC ? seconTominutesConveter(data?.MAX_DEVICE_UP_TIME_SEC) : '0'}</td>}
                                                {tabShow === true ? '' : <td className="text-center">{JSON.parse(data?.HEARTBEAT_LAST_DATA || '{}')?.DWKPCNT}</td>}
                                                {tabShow === false && ModelId == 'Under Maintanance' ? <td className="text-center"><BootstrapTooltip title={data?.CHANGE_STATUS_TS ? moment.utc(data.CHANGE_STATUS_TS).format('DD-MM-YYYY hh:mm:ss A') : ''}><div className="badge badge-success badge-shadow text-white" >{data?.CHANGE_STATUS_TS ? moment.utc(data.CHANGE_STATUS_TS).add(-moment().utcOffset(), "m").fromNow('ss:hh:mm') : ''}</div></BootstrapTooltip></td> : ''}

                                            </tr>
                                        )) : <tr></tr>}
                                </tbody>
                            </table>
                        )}
                        {sortedData.length === 0 && !ModalLoad && <h4 className="text-center">No Data Found</h4>}
                    </div>
                </BootstrapModal.Body>
            </BootstrapModal>
        </Suspense>
    );
}